import { render, staticRenderFns } from "./SCardDetailPurchaseComp.vue?vue&type=template&id=b5455c6e&"
import script from "./SCardDetailPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./SCardDetailPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports